import * as Cookies from 'js-cookie'
export const state = () => ({
  language: null,
  possibleLanguages: ['en', 'de'],
  navigation: null,
  loading: false,
  languagePaths: null
})
export const getters = {
  language(state) {
    return state.language
  },
  possibleLanguages(state) {
    return state.possibleLanguages
  },
  navigation(state) {
    return state.navigation
  },
  footer(state) {
    return state.footer
  },
  loading(state) {
    return state.loading
  },
  languagePaths(state) {
    return state.languagePaths
  }
}
export const mutations = {
  setLanguage(state, { language }) {
    if (state.possibleLanguages.includes(language)) {
      this.app.head.htmlAttrs.lang = language
      state.language = language
      Cookies.set('language', language, {
        expires: 365,
        secure: false
      })
      this.app.store.dispatch('getNavigation')
      this.app.store.dispatch('general/application/getApplicationForm')
      this.app.store.dispatch('general/application/getThankYou')
      this.app.store.dispatch('general/contact/getContactForm')
      this.app.store.dispatch('general/contact/getThankYou')
      this.app.store.dispatch('general/event/getEventForm')
      this.app.store.dispatch('general/event/getThankYou')
      this.app.store.dispatch('general/event/getDoubleOptIn')
      this.app.store.dispatch('getFooter')
      if (
        process.browser &&
        window &&
        window.OneTrust &&
        typeof window.OneTrust.changeLanguage == 'function'
      ) {
        window.dispatchEvent(new CustomEvent('languageChange'))
        setTimeout(() => {
          window.OneTrust.changeLanguage(language.toLowerCase())
        }, 300)
      }
    }
  },
  setNavigation(state, { data }) {
    state.navigation = data
  },
  setFooter(state, { data }) {
    state.footer = data
  },
  setLoading(state, { data }) {
    state.loading = data
  },
  setLanguagePaths(state, { data }) {
    let mappedData = []
    Object.keys(data).forEach((language) => {
      data[language].paths.forEach((path, idx) => {
        if (!mappedData[idx]) {
          mappedData[idx] = {}
        }
        if (path) {
          mappedData[idx][language] = {
            language: language,
            idx: idx,
            path: path,
            isActive: null
          }
        }
      })
    })
    state.languagePaths = mappedData
  }
}
export const actions = {
  nuxtServerInit() {
    return Promise.all([this.app.store.dispatch('getLanguagePaths')])
  },
  getNavigation({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/navigation.json`)
      .then((res) => {
        commit('setNavigation', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getFooter({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/footer.json`)
      .then((res) => {
        commit('setFooter', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getLanguagePaths({ commit }) {
    return this.$axios
      .get('language_mapping.json')
      .then((res) => {
        commit('setLanguagePaths', { data: res.data })
        // return Promise.all([
        //   // this.app.store.dispatch('getLanguagePaths'),
        //   this.app.store.dispatch('getNavigation'),
        //   this.app.store.dispatch('getFooter')
        // ])
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
